import CommonSingleStepUploader from './CommonSingleStepUploader';
import BULK_UPLOADER_TITLE from './constants';
import apiConfig from '../../API_Utils/APIUtil/ApiConfig';
import { BULK_UPLOAD_INVOICE_TYPES } from '../../constants';

const SOAppointment = () => {
  return (
    <CommonSingleStepUploader
      key="so-appointment"
      header={BULK_UPLOADER_TITLE['so-appointment']}
      invoiceType={BULK_UPLOAD_INVOICE_TYPES.DOMESTIC_ONLINE}
      sampleEndpoint={apiConfig.bulkUploader.soAppointment.sample}
      selectionKey="so-appointment-bulk"
      submitEndpoint={apiConfig.bulkUploader.soAppointment.submit}
      title="SO Appointment"
      validationEndpoint={apiConfig.bulkUploader.soAppointment.validate}
    />
  );
};

export default SOAppointment;
